import type { QR_CODE_TYPES } from "./types";

export const QR_CODE = {
    barcode_1d: "barcode_1d",
    barcode_2d: "barcode_2d",
} as const;

export const QR_CODE_TOOLTIP: Record<QR_CODE_TYPES, string> = {
    [QR_CODE.barcode_1d]: "barcode_tooltip",
    [QR_CODE.barcode_2d]: "qr_code_tooltip",
};

export const QR_CODE_DESCRIPTION: Record<QR_CODE_TYPES, string> = {
    [QR_CODE.barcode_1d]: "barcode_description",
    [QR_CODE.barcode_2d]: "qr_code_description",
};

export const QR_CODE_DOWNLOAD: Record<QR_CODE_TYPES, string> = {
    [QR_CODE.barcode_1d]: "barcode_download",
    [QR_CODE.barcode_2d]: "qr_code_download",
};

export const QR_DOWNLOAD_IMAGE_WIDTH: Record<QR_CODE_TYPES, number> = {
    [QR_CODE.barcode_1d]: 200,
    [QR_CODE.barcode_2d]: 244,
};

export const QR_DOWNLOAD_IMAGE_HEIGHT: Record<QR_CODE_TYPES, number> = {
    [QR_CODE.barcode_1d]: 120,
    [QR_CODE.barcode_2d]: 244,
};

export const QR_CANVAS_WIDTH = 500;
export const QR_CANVAS_HEIGHT = 320;
export const QR_SHOP_LOGO_WIDTH = 200;
export const QR_SHOP_LOGO_HEIGHT = 100;
